import ToolData from '@editorjs/editorjs';

interface ButtonToolData extends ToolData {
  text: string;
  link?: string;
}

const buttonParser = ({ data }: { data: ButtonToolData }): string => {
  const buttonText = data.text || 'Click me';
  const buttonLink = data.link ? `href="${data.link}" target="_blank"` : '';

  return `<a ${buttonLink} style="display:block"><button style="background-color: rgba(0, 148, 145, 1); min-width: 136px; height: 48px; padding: 13px 20px; border-radius: 12px; border: none; font-size: 16px; font-family: 'Inter',sans-serif; cursor:pointer; font-weight: semi-bold; margin-top:10px; margin-bottom:10px; color: rgba(255, 255, 255, 1);">${buttonText}</button></a>`;
};

export default buttonParser;
